var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentTypeFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.4V6C15 6.66274 15.5373 7.2 16.2 7.2H19.8M8.4 7.2H10.8M8.4 10.8H15.6M8.4 14.4H15.6M18 4.2C17.4661 3.72204 16.9119 3.15528 16.5621 2.78718C16.3292 2.54224 16.0076 2.4 15.6696 2.4H6.6C5.27452 2.4 4.2 3.47452 4.2 4.8V19.2C4.2 20.5255 5.27452 21.6 6.6 21.6H17.4C18.7255 21.6 19.8 20.5255 19.8 19.2V6.478C19.8 6.171 19.683 5.876 19.47 5.655C19.076 5.247 18.419 4.574 18 4.2Z",
    stroke: "#B0B0B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentTypeFilter);
export default __webpack_public_path__ + "static/media/content-type-filter.846d5e76f5b535d7baaa2a15d70bbe97.svg";
export { ForwardRef as ReactComponent };